export class PrePressSpecification {
  componentProofSoft: string | undefined;
  componentPrepPrint: string | undefined;
  proofSoft: string | undefined;
  prepPrint: string | undefined;

  constructor() {
    this.componentProofSoft = undefined;
    this.componentPrepPrint = undefined;
    this.proofSoft = undefined;
    this.prepPrint = undefined;
  }
}
